/* eslint-disable */
import 'intersection-observer'
require('es6-object-assign').polyfill()

if (!Object.entries) {
  Object.entries = function(obj) {
    var ownProps = Object.keys(obj),
      i = ownProps.length,
      resArray = new Array(i) // preallocate the Array
    while (i--) resArray[i] = [ownProps[i], obj[ownProps[i]]]

    return resArray
  }
}



// WEBPACK FOOTER //
// ./src/v1/client.polyfill.js